import { render, staticRenderFns } from "./dashboardUnidadesObjetivos.vue?vue&type=template&id=086edba7&scoped=true&"
import script from "./dashboardUnidadesObjetivos.vue?vue&type=script&lang=js&"
export * from "./dashboardUnidadesObjetivos.vue?vue&type=script&lang=js&"
import style0 from "./dashboardUnidadesObjetivos.vue?vue&type=style&index=0&id=086edba7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086edba7",
  null
  
)

export default component.exports